import React, { useEffect, useState } from "react";
import { get, deleteRequest } from "api";
import DataTable from "react-data-table-component";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import { IListVouchers } from "types/voucher";

const ListVoucher = () => {
  const history = useHistory();
  const [voucher, setVoucher] = useState<IListVouchers[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    get("/voucher")
      .then((response) => {
        setVoucher(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching voucher data:", err);
        setLoading(false);
      });
  }, []);

  const handleEditClick = (code: string) => {
    history.push(`/dashboard/edit-voucher/${code}`);
  };

  const handleDeleteClick = (id: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this voucher?"
    );
    if (confirmDelete) {
      deleteRequest(`/voucher/${id}`)
        .then(() => {
          return get("/voucher");
        })
        .then((response) => {
          setVoucher(response.data);
        })
        .catch((error) => {
          console.error("Error deleting voucher:", error);
        });
    }
  };

  const handleRowClicked = (row: IListVouchers) => {
    history.push(`/dashboard/edit-voucher/${row.code}`);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value.toLowerCase();
    setSearchQuery(keyword);
  };

  const columns = [
    {
      name: "Code",
      selector: (row: IListVouchers) => row.code,
      sortable: true,
      grow: 1,
    },
    {
      name: "Discount",
      selector: (row: IListVouchers) => row.discount,
      sortable: true,
    },
    {
      name: "Limit",
      selector: (row: IListVouchers) => row.limit,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row: IListVouchers) => (
        <div className="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            onClick={() => handleEditClick(row.code)}
            className="btn btn-warning me-2"
          >
            Edit
          </button>

          <button
            type="button"
            onClick={() => handleDeleteClick(row._id)}
            className="btn btn-danger"
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        minWidth: "100%",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    search: {
      style: {
        position: "relative",
        width: "100%",
      },
    },
    searchInput: {
      style: {
        width: "100%",
      },
    },
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="d-flex align-items-center w-100">
        <input
          type="text"
          placeholder="Search vouchers..."
          onChange={handleSearch}
          className="form-control me-2"
          value={searchQuery}
        />
        <div className="cursor-pointer" onClick={() => setSearchQuery("")}>
          <RefreshIcon />
        </div>
      </div>
    );
  }, [searchQuery]);

  const filteredVouchers = voucher.filter(
    (vouchers) =>
      vouchers.code.toLowerCase().includes(searchQuery) ||
      vouchers.expireAt.toLowerCase().includes(searchQuery)
  );

  return (
    <div className="">
      <div className="w-100">
        <h3>Voucher List</h3>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={30} />
          </div>
        ) : (
          <DataTable
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            data={filteredVouchers}
            columns={columns}
            pagination
            paginationPerPage={10}
            customStyles={customStyles}
            onRowClicked={handleRowClicked}
            highlightOnHover
            pointerOnHover
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ListVoucher;
